import { VideosPackageResponse } from '@/types/videos'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { theme } from '@/theme/theme'

const PackageCardVideosDetails = ({ videosPackage }: { videosPackage: VideosPackageResponse }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" alignItems="center">
      <Box display="flex" alignItems="center">
        <Typography padding={theme.spacing(0, 1)} fontSize={14} fontWeight={theme.typography.fontWeightMedium}>
          {t('videoLibrary.videos')}:
        </Typography>
        <Typography paddingRight={theme.spacing(1)} fontSize={14}>
          {videosPackage.videos.length}
        </Typography>
        <Typography padding={theme.spacing(0, 1)} fontSize={14} fontWeight={theme.typography.fontWeightMedium}>
          {t('videoLibrary.quizzes')}:
        </Typography>
        <Typography paddingRight={theme.spacing(1)} fontSize={14}>
          {
            videosPackage.videos.filter((video) => video.number_of_quiz_questions && video.number_of_quiz_questions > 0)
              .length
          }
        </Typography>
      </Box>
    </Box>
  )
}
export default PackageCardVideosDetails
